import indicadorReportSummary from "entity/Indicador/reports/IndicadorReportSummary";
import TableReportHelper from "report/helper";

export default async function ReportSummary(indicador, visita, tipoName) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const params = visita.cliente.getParams(IndicadorClass, tipoName, indicador.type)

    if (!params) {
        return null;
    }

    async function getChart(conformidade) {
        let ton = (Math.abs(conformidade) / 1000).toFixed(0)

        return h.row(h.text(ton + " ton", { alignment: "center", fontSize: 40, colSpan: 2 }),)
    }

    return indicadorReportSummary(
        indicador,
        visita,
        tipoName,
        params,
        getChart,
        "kg",
        "conformidade",
        true,
        false /*showMeta: */
    )
}
